import React, { useState, useEffect } from 'react';
import { Card } from 'flowbite-react';
import clsx from 'clsx';

import Stripe from "./payment-methods/Stripe";
import AsiaPayClient from "./payment-methods/AsiaPayClient";
import AsiaPayDirectLink from "./payment-methods/AsiaPayDirectLink";
import LimePay from "./payment-methods/LimePay";
import PayWithPoints from "./payment-methods/PayWithPoints";

import { Accordion } from 'flowbite-react';

import americanExpress from '../../assets/images/payment-american-express.png';
import mastercard from '../../assets/images/payment-mastercard.png';
import visa from '../../assets/images/payment-visa.png';

import radioOn from '../../assets/icons/radio-on.svg';
import radioOff from '../../assets/icons/radio-off.svg';

let couponExists = false;

export default function PaymentMethod({pmName, isRenewalPage, pwpEnabled, languages, isPwpPointsEnabled, pwpData, isUserLogged, updateCurrentPaymentMethodActive, transactionId, loadPaymentMethod, member, locationData, index, directLink, total, nbPoints, enoughNbPoints, goNextStep, localStorageDatas, memberId, accordionIndex, toggleShowAccordion, activeCurrentIndex,  price_level_text, pwpBcEnabled, pmid, bcState}) {


    // console.log('pwpData', member.selected_product[0].isQbr)
    // !member.selected_product[0].isQbr
    // member.selected_product[0].isQbr
    

    var totalnum = 0;
    var totalGst = 0;
    var currencyText = "";
  
    if(Object.keys(localStorageDatas.members[0]?.selected_product).length !== 0) {
        if(localStorageDatas && localStorageDatas.members.length > 0 && localStorageDatas.members[0].selected_product && localStorageDatas.members[0].selected_product[0].currency_text) {
        currencyText = localStorageDatas.members[0].selected_product[0].currency_text;
        }
    }

    if(Object.keys(localStorageDatas.members[0].selected_product).length !== 0) {
        for(var i = 0; i < localStorageDatas.members.length; i++) {
        let price = "";
        let gst = "";
        if(localStorageDatas.members[0].selected_product && localStorageDatas.members[0].selected_product[0].purchase_price) {
            price = parseFloat(localStorageDatas.members[i].selected_product[0].purchase_price)
            gst = parseFloat(localStorageDatas.members[i].selected_product[0].tax_amt)
        }
        totalnum += price;
        totalGst += gst
        }
        var totalAmt = totalnum + totalGst;
    }

    var couponExists = false;
    var totalAmount  = "";

    function PaymentReview({name}) {
        return (
          <>
            <div className='holder-content-receipt tablet:bordered-gray tablet:bg-white py-10 tablet:px-5'>
                <div className='content-receipt'>
                  {
                    couponExists == false ? (
                      <div>
                        <div className='receipt-list w-full flex flex-row mb-3'>
                          <p className='title text-gray'>Sub Total</p>
                          <p className='value ml-auto'>{(totalnum).toFixed(2)} <span className='uppercase'>{currencyText}</span></p>
                        </div>
                        <div className='receipt-list w-full flex flex-row'>
                          <p className='title text-gray'>GST</p>
                          <p className='value ml-auto'>{(totalGst).toFixed(2)} <span className='uppercase'>{currencyText}</span></p>
                        </div>
                        <div className='lining'></div>
                      </div>
                    ) : ""
                  }
                  
                  <div className='receipt-list w-full total flex flex-row'>
                    <p className='title text-gray'>Total </p>
                    <p className='value ml-auto pl-1'>
                      <span className='font-bold'>{(couponExists ? '  ' + totalAmount : parseInt(totalAmt).toFixed(2))} </span>
                      <span className='uppercase'>{!couponExists ? currencyText : ""}</span>
                    </p>
                  </div>
                </div>
            </div>
          </>
        );
    }

    let customClass = (activeCurrentIndex === accordionIndex ? "button-wrapper" : "remove-lines mb-3") + "";
    if(!pmName) return;
    if(pmName == "Stripe") {
        return (
            <Accordion.Panel key={index} isOpen={activeCurrentIndex === accordionIndex} tabIndex={index}>
                <div className={customClass}>
                    <Accordion.Title onClick={() => toggleShowAccordion(accordionIndex, pmName)}>
                        
                        <div class="flex">
                            <div class="flex mr-5">
                                {(activeCurrentIndex === accordionIndex ? <img src={radioOn}/> : <img src={radioOff}/>)}
                            </div>
                            <React.Fragment>
                                {
                                    locationData.PaymentMethod[pmName].Image.map((i) => {
                                        if(locationData.PaymentMethod[pmName].Image && locationData.PaymentMethod[pmName].Image.length > 0) {
                                            let img = require('../../assets/images/' + i);
                                            return <img src={img} width="42" class="mr-2" />;
                                        } else {
                                            return locationData.PaymentMethod[pmName].TabName || pmName;
                                        }
                                    })
                                }
                            </React.Fragment>
                        </div>
                    </Accordion.Title>
                </div>
                <div className='holder-content'>
                    <Accordion.Content>
                    <PaymentReview 
                        name={pmName}
                    />
                    {                    
                        loadPaymentMethod.filter(x => x.name === pmName)[0].show &&
                        <Stripe transactionId={transactionId || ""} member={member || {}} locationData={locationData} goNextStep={goNextStep} localStorageDatas={localStorageDatas} />               
                    }
                    </Accordion.Content> 

                </div>
            </Accordion.Panel>
        )
    } 
    
    else if(pmName == "AsiaPay" || pmName == "DIRECT") {
        return (
            <Accordion.Panel key={index} isOpen={activeCurrentIndex === accordionIndex} tabIndex={index}>
                <div className={customClass}>
                    <Accordion.Title onClick={() => toggleShowAccordion(accordionIndex, pmName)}>
                        <div class="flex">
                            <div class="flex mr-5">
                                {(activeCurrentIndex === accordionIndex ? <img src={radioOn}/> : <img src={radioOff}/>)}
                            </div>
                            <React.Fragment>
                                {
                                    locationData.PaymentMethod[index].pMethod.map(i => {
                                        if(i) {
                                            //return (i.image ? i.image : "test");
                                            let img, imgSize;
                                            if(locationData.PaymentMethod[index].dinerBC && bcState == locationData.PaymentMethod[index].dinerBC && locationData.PaymentMethod[index].dinerProps) {
                                                img = require('../../assets/images/' + locationData.PaymentMethod[index].dinerProps.image);
                                                imgSize = locationData.PaymentMethod[index].dinerProps.widthSize;
                                            } else if(locationData.PaymentMethod[index].visaBC && bcState == locationData.PaymentMethod[index].visaBC && locationData.PaymentMethod[index].visaProps) {
                                                img = require('../../assets/images/' + locationData.PaymentMethod[index].visaProps.image);
                                                imgSize = locationData.PaymentMethod[index].visaProps.widthSize;
                                            } else if(locationData.PaymentMethod[index].jcbBC && bcState == locationData.PaymentMethod[index].jcbBC && locationData.PaymentMethod[index].jcbProps) {
                                                img = require('../../assets/images/' + locationData.PaymentMethod[index].jcbProps.image);
                                                imgSize = locationData.PaymentMethod[index].jcbProps.widthSize;
                                            } else {
                                                img = require('../../assets/images/' + i.image);
                                                imgSize = i.widthSize;
                                            }
                                            return <img src={img} width={imgSize} />;
                                        } else {
                                            return locationData.PaymentMethod[index].TabName || pmName;
                                        }
                                    })
                                }
                            </React.Fragment>
                        </div>
                    </Accordion.Title>
                </div>    
                <div className='holder-content'>
                    <Accordion.Content>
                    <PaymentReview 
                        name={pmName}
                    />
                    {                
                        loadPaymentMethod.filter(x => x.name === pmName)[0].show &&
                        <AsiaPayClient transactionId={transactionId || ""} pMethod={pmName} member={member || {}} locationData={locationData} goNextStep={goNextStep} bcState={bcState} />    
                    }                
                    </Accordion.Content> 
                </div>       
            </Accordion.Panel>
        )
    } 
    
    else if(pmName == "LimePay") {
        return (
            <Accordion.Panel key={index} isOpen={activeCurrentIndex === accordionIndex} tabIndex={index}>
                <div className={customClass}>                    
                    <Accordion.Title onClick={() => toggleShowAccordion(accordionIndex, pmName)}>
                        <div class="flex">
                            <div class="flex mr-5">
                                {(activeCurrentIndex === accordionIndex ? <img src={radioOn}/> : <img src={radioOff}/>)}
                            </div>
                            <React.Fragment>
                                {
                                    locationData.PaymentMethod[pmName].Image?.map((i) => {
                                        if(locationData.PaymentMethod[pmName].Image && locationData.PaymentMethod[pmName].Image.length > 0) {
                                            let img = require('../../assets/images/' + i);
                                            return <img src={img} width="50" />;
                                        } 
                                    })
                                }
                            </React.Fragment>
                            {locationData.PaymentMethod[pmName].TabName || pmName}
                        </div>
                    </Accordion.Title>
                </div>
                <div className='holder-content'>
                    <Accordion.Content>
                    <PaymentReview 
                        name={pmName}
                    />
                    {
                        loadPaymentMethod.filter(x => x.name === pmName)[0].show &&
                        <LimePay transactionId={transactionId || ""} member={member || {}} locationData={locationData} goNextStep={goNextStep} total={total} localStorageDatas={localStorageDatas} memberId={memberId}  price_level_text={price_level_text} />               
                    }
                    
                    </Accordion.Content>   
                </div>
            </Accordion.Panel>
        )
    } 
   
    else if(directLink) {
        return (
            <Accordion.Panel key={index} isOpen={activeCurrentIndex === accordionIndex} tabIndex={index}>
                <div className={customClass}>
                    <Accordion.Title onClick={() => toggleShowAccordion(accordionIndex, pmName)}>
                        <div class="flex">
                            <div class="flex mr-5">
                                {(activeCurrentIndex === accordionIndex ? <img src={radioOn}/> : <img src={radioOff}/>)}
                            </div>
                            <React.Fragment>
                                {
                                    locationData.PaymentMethod[index]?.pMethod.filter(pMethod => {
                                        let img = require('../../assets/images/' + pMethod.image);
                                        //return <img src={img} width={pMethod.widthSize} />
                                        return (pMethod.pmCode === pmName);
                                    }).map((i) => {
                                        if(locationData.PaymentMethod[index].pMethod && locationData.PaymentMethod[index].pMethod.length > 0) {
                                            let img = require('../../assets/images/' + i.image);
                                            return <img src={img} width={i.widthSize} />;
                                        } else {
                                            return locationData.PaymentMethod[index].TabName || pmName;
                                        }
                                    })
                                }
                            </React.Fragment>
                        </div>
                    </Accordion.Title>
                </div>
                <div className='holder-content'>
                    <Accordion.Content>  
                    <PaymentReview 
                        name={pmName}
                    />                  
                    {
                        loadPaymentMethod.map((item) => {
                            if(item.name === pmName && item.show === true) {
                                return (
                                    <AsiaPayDirectLink 
                                        transactionId={transactionId || ""} 
                                        member={member || {}} 
                                        locationData={locationData} 
                                        pMethod={pmName} 
                                        goNextStep={goNextStep} 
                                    />
                                )
                            }
                        })
                    }
                    </Accordion.Content>                                        
                </div>
            </Accordion.Panel>
        )
    } 

    
    else if(pmName == "PayWithPoints") {
        if((!pwpBcEnabled || (!nbPoints && (nbPoints <= 0 || !enoughNbPoints))) && pwpData.exists && (!member[0].selected_product[0].isQbr)) {
            return (
                <Accordion.Panel key={index} isOpen={activeCurrentIndex === accordionIndex} tabIndex={index}>
                    <Accordion.Title onClick={() => toggleShowAccordion(accordionIndex)}>
                        <div class="flex">
                            <div class="flex mr-5">
                                {(activeCurrentIndex === accordionIndex ? <img src={radioOn}/> : <img src={radioOff}/>)}
                            </div>
                            <React.Fragment>
                                {
                                    locationData.PaymentMethod[pmName].Image.map((i) => {
                                        if(locationData.PaymentMethod[pmName].Image && locationData.PaymentMethod[pmName].Image.length > 0) {
                                            let img = require('../../assets/images/' + i); 
                                            return (
                                                <>
                                                    <img src={img} width="75" />
                                                    <span className='my-auto pl-3 font-montsterrat font-bold'>ALL Reward Points</span>
                                                </>
                                            );
                                        } else {
                                            return locationData.PaymentMethod[pmName].TabName || pmName;
                                        }
                                    })
                                }
                            </React.Fragment>
                        </div>
                    </Accordion.Title>
                    <div className='holder-content'>
                        <Accordion.Content>
                        <div className='holder-content-receipt tablet:bordered-gray tablet:bg-white py-10 tablet:px-5'>
                            <div className='content-receipt'>
                                {
                                    couponExists == false ? (
                                    <div>
                                        
                                        <div className='receipt-list w-full flex flex-row mb-3'>
                                            <p className='title text-gray'>{languages && languages.subTotal ? languages.subTotal : 'Sub Total'}</p>
                                            <p className='value ml-auto'>0.00 <span>{locationData.currency ? locationData.currency : ''}</span></p>
                                        </div>
                                        <div className='receipt-list w-full flex flex-row'>
                                            <p className='title text-gray'>{languages && languages.gst ? languages.gst : 'GST'}</p>
                                            <p className='value ml-auto'>0.00 <span>{locationData.currency ? locationData.currency : ''}</span></p>
                                        </div>
                                        <div className='lining'></div>
                                    </div>
                                    ) : ""
                                }
                            
                                <div className='receipt-list w-full total flex flex-row'>
                                    <p className='title text-gray'>{languages && languages.total ? languages.total : 'Total'} </p>
                                    <p className='value ml-auto pl-1'>
                                    <span className='total-amount font-medium'>{pwpData.points ? pwpData.points : '0.00'}</span>                                                                         
                                    <span className='uppercase'> {languages && languages.pwpRewardPointsMessage ? languages.pwpRewardPointsMessage : 'ALL - Accor Live Limitless reward points'}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        {
                            isUserLogged ? (
                                <>
                                    {
                                        nbPoints ? ( //check here for points if enough
                                            <>
                                                {
                                                    loadPaymentMethod.filter(x => x.name === pmName)[0].show &&
                                                    <PayWithPoints 
                                                        transactionId={transactionId || ""} 
                                                        member={member || {}} 
                                                        locationData={locationData} 
                                                        languages={languages}
                                                        pMethod={pmName} 
                                                        nbPoints={nbPoints} 
                                                        enoughNbPoints={enoughNbPoints} 
                                                        localStorageDatas={localStorageDatas} 
                                                        pmid={pmid} 
                                                        goNextStep={goNextStep}
                                                        isPwpPointsEnabled={isPwpPointsEnabled}
                                                        isRenewalPage={isRenewalPage}
                                                    />
                                                }
                                            </>
                                        ) : ( //not enough points
                                            <>
                                                {
                                                    loadPaymentMethod.filter(x => x.name === pmName)[0].show &&
                                                    <PayWithPoints 
                                                        transactionId={transactionId || ""} 
                                                        member={member || {}} locationData={locationData} 
                                                        languages={languages}
                                                        pMethod={pmName} nbPoints={nbPoints} 
                                                        enoughNbPoints={enoughNbPoints} 
                                                        localStorageDatas={localStorageDatas} 
                                                        pmid={pmid} 
                                                        isPwpPointsEnabled={isPwpPointsEnabled}
                                                        goNextStep={goNextStep}
                                                        isRenewalPage={isRenewalPage}
                                                    />
                                                }
                                            </>
                                        )
                                    }
                                </>
                            ) : (
                                
                                <div className='holder-text text-center mt-5 mb-5'>                                    
                                    <div className='holder-title mb-2'>
                                        <h5 className='text-xl tracking-tight text-gray-900 dark:text-white font-montsterrat font-bold'>{languages && languages.pwpLoginMessageError ? languages.pwpLoginMessageError : 'You are not logged in'}</h5>
                                    </div>
                                    <div>
                                        <p className='pt-1 font-montsterrat'>{languages && languages.pwpLoginMessage ? languages.pwpLoginMessage : 'Please log in with your ALL credentials.'}</p>
                                    </div>
                                    <div className='mt-4'>
                                        <a href="https://login.accor.com/as/authorization.oauth2?client_id=com.accorplus&response_type=code&persistent=yes&scope=openid+PROFILE.READ+PROFILE.WRITE+PROFILE.WALLET&redirect_uri=https%3A%2F%2Fwww.accorplus.com%2Fcallback" target="_blank" className='btn btn-blue inline-block px-6 py-2.5 text-white font-montsterrat font-medium leading-tight uppercase rounded shadow-md ease-in-out'>{languages && languages.pwpLoginButton ? languages.pwpLoginButton : 'LOG IN'}</a>
                                    </div>
                                </div>
                            )
                        }
                        
                        </Accordion.Content>
                    </div>
                </Accordion.Panel>
            )
        } 
    } 
    


    else {
        return (
            <Accordion.Panel key={index} isOpen={activeCurrentIndex === accordionIndex} tabIndex={index}>
                <Accordion.Title onClick={() => toggleShowAccordion(accordionIndex)}>
                    {/* {locationData.PaymentMethod[pmName].TabName || pmName} */}
                </Accordion.Title>
                <Accordion.Content>
                    No Payment Method
                </Accordion.Content>
            </Accordion.Panel>
        )
    }
}
